import { render } from "./DockerLoadImage.vue?vue&type=template&id=fe145086"
import script from "./DockerLoadImage.vue?vue&type=script&lang=js"
export * from "./DockerLoadImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__